import React from 'react'
import PropTypes from 'prop-types'
import { BrowserRouter, StaticRouter, Route } from 'react-router-dom'
import { branch } from 'baobab-react/higher-order'
import StudyFields from 'components/pages/StudyFields'
import Locations from 'components/pages/Locations'
import AptitudeLanding from 'components/pages/AptitudeLanding'
import AptitudeInstruction from 'components/pages/AptitudeInstruction'
import AptitudeTest from 'components/pages/AptitudeTest'
import AptitudeCalculate from 'components/pages/AptitudeCalculate'
import AptitudeReport from 'components/pages/AptitudeReport'
import AptitudeHistory from 'components/pages/AptitudeHistory'
import AptitudeRecommendation from 'components/pages/AptitudeRecommendation'
import * as Scholarship from 'components/pages/Scholarship'
import Koinworks from 'components/pages/Koinworks'
import Majors from 'components/pages/Majors'
import MajorDetail from 'components/pages/MajorDetail'
import Careers from 'components/pages/Careers'
import CareerDetail from 'components/pages/CareerDetail'
import Directory from 'components/pages/Directory'
import SchoolDetail from 'components/pages/SchoolDetail'
import Faculty from 'components/pages/Faculty'
import Likes from 'components/pages/Likes'
import Materials from 'components/pages/Materials'
import StaticHtml from 'components/pages/StaticHtml'
import Profile from 'components/pages/Profile'
import KITLanding from 'components/pages/KITLanding'
import Partners from 'components/pages/Partners'
import TestsDirectory from 'components/pages/TestsDirectory'
import TestDetail from 'components/pages/TestDetail'
import Interest from 'components/pages/Interest'
import PintariaLanding from 'components/pages/PintariaLanding'
import Scholarships from 'components/pages/Scholarships'
import ScholarshipDetail from 'components/pages/ScholarshipDetail'
import ScholarshipAward from 'components/pages/ScholarshipAward'
import { MaintenancePage } from 'components/pages/Errors'
import PeluangSBMPTNLanding from 'components/pages/PeluangSBMPTNLanding'
import PaperplaneReattempt from 'components/pages/Paperplane/PaperplaneReattempt'
import PaperplaneResult from 'components/pages/PaperplaneResult'
import PaperplaneReview from 'components/pages/Paperplane/PaperplaneReview'

const Mapper = ({ currentPath }) => {
  const Router = (typeof window !== 'undefined') ? BrowserRouter : StaticRouter

  return (
    <Router location={currentPath} context={{}}>
      <div>
        <Route exact path="/fields-of-study" component={StudyFields} />
        <Route exact path="/locations" component={Locations} />
        <Route exact path="/aptitude_test" component={AptitudeLanding} />
        <Route exact path="/aptitude_test/instruction" component={AptitudeInstruction} />
        <Route exact path="/aptitude_test/test/:page" component={AptitudeTest} />
        <Route exact path="/aptitude_test/calculate" component={AptitudeCalculate} />
        <Route exact path="/aptitude_test/report/:id" component={AptitudeReport} />
        <Route exact path="/aptitude_test/history" component={AptitudeHistory} />
        <Route exact path="/aptitude_test/recommendation/:id" component={AptitudeRecommendation} />
        <Route exact path="/recommended-campus" component={Interest} />
        <Route exact path="/scholarship" component={Scholarship.Winners} />
        <Route exact path="/scholarship/about" component={Scholarship.About} />
        <Route exact path="/scholarships/award/form" component={ScholarshipAward} />
        <Route exact path="/scholarships" component={Scholarships} />
        <Route exact path="/scholarships/:slug" component={ScholarshipDetail} />
        <Route exact path="/koinworks" component={Koinworks} />
        <Route exact path="/majors" component={Majors} />
        <Route exact path="/majors/:slug" component={MajorDetail} />
        <Route exact path="/careers" component={Careers} />
        <Route exact path="/careers/:slug" component={CareerDetail} />
        <Route exact path="/directory" component={Directory} />
        <Route exact path="/directory/:school_slug/faculties/:slug" component={Faculty} />
        <Route exact path="/directory/:slug" component={SchoolDetail} />
        <Route exact path="/likes/:kind" component={Likes} />
        <Route exact path="/materials" component={Materials} />
        <Route exact path="/terms" component={StaticHtml} />
        <Route exact path="/profile" component={Profile} />
        <Route exact path="/partners" component={Partners} />
        <Route exact path="/tests" component={TestsDirectory} />
        <Route exact path="/tests/:slug" component={TestDetail} />
        <Route exact path="/kit-cambodia" component={KITLanding} />
        <Route exact path="/pintaria" component={PintariaLanding} />
        <Route exact path="/peluang-sbmptn" component={PeluangSBMPTNLanding} />
        <Route exact path="/peluang-sbmptn/submit-interest" component={PaperplaneReattempt} />
        <Route exact path="/peluang-sbmptn/result" component={PaperplaneResult} />
        <Route exact path="/peluang-sbmptn/review" component={PaperplaneReview} />
        <Route exact path="/error/503" component={MaintenancePage} />
      </div>
    </Router>
  )
}

Mapper.propTypes = {
  currentPath: PropTypes.string,
}

Mapper.defaultProps = {
  currentPath: '',
}

export default branch({
  currentPath: ['serverProps', 'currentPath'],
}, Mapper)
